import config from 'config';

export const { app: APP_CONFIG } = config;

export * as utilities from 'core/utilities';
export * from 'core/domains';
export * from 'core/store';
export * from 'core/services';

export {
  app,
  cart,
  catalog,
  checkout,
  combo,
  content,
  extendedCaptation,
  order,
  search,
  sections,
  settings,
  showcases,
  user,
  shippingModel,
} from 'core/use-cases';
